import useStep from 'booking/hooks/useStep';
import * as React from 'react';
import Logo from 'assets/logoWithText.inline.svg';
import { useSelector } from 'react-redux';
import { getSteps } from 'booking/redux/selectors';
import { Link } from 'gatsby';
import classNames from 'classnames';
import * as styles from './BookingHeader.module.scss';
import BackButton from '../BackButton';

export default function BookingHeader() {
    const { step } = useStep();
    const steps = useSelector(getSteps);

    const showBackButton = step !== 'finished' && step !== steps[0];

    return (
        <header
            className={classNames(styles.root, {
                [styles.finished]: step === 'finished',
            })}
        >
            {showBackButton && <BackButton />}
            <Link to="/" className={styles.logoLink}>
                <Logo className={styles.logo} />
                <span className="sr-only">Home</span>
            </Link>
        </header>
    );
}
